module.exports = __webpack_public_path__ + "static/media/logo.74e9b9fc.png";